define('modules/login/controller/Login',[], function() {
	var Controller = function(
		$scope,
		Auth,
		Studio,
		Token,
		$location,
		$stateParams,
		RiferimentiStudio,
		CredenzialiUtente,
		$modal,
		LocalStorage) {

			/*var cookieModal = {
				animation: true,
				templateUrl: 'modules/common/view/modalCookie.tpl.html',
				controller: 'ModalCookieController',
				size: "lg"
			};


			if (!LocalStorage.getItem('DisclaimerAccept1-1-5', false)) {
				cookieModal.backdrop = "static";
				$modal.open(cookieModal);
			}*/

		$scope.validStudioName = /^([a-zA-Z0-9_-]){0,27}$/;
		$scope.loading = false;
		$scope.user = {
			alias: "",
			username: "",
			password: ""
		};
		$scope.errors = {};
		$scope.presetAlias = ($stateParams.aliasStudio && $stateParams.aliasStudio !== "studio" && $stateParams.aliasStudio !== "undefined") ? $stateParams.aliasStudio : "";
		$scope.rememberLogin = CredenzialiUtente.getRicordaPassword();

		$scope.$on('$stateChangeSuccess',
			function(event, toState, toParams, fromState, fromParams) {
				//Se non ho rememberMe o le credenziali devo tornare a Login
				if ($scope.rememberLogin) {
					executeAutoLogin();
				}
			}
		);

		var manageError = function(error) {
			if (error.status === 401) {
				$scope.errors.denied = true;
			} else if (error.status === 404) {
				$scope.errors.alias = true;
			} else {
				$scope.errors.communication = true;
			}
		};

		var executeAutoLogin = function() {
			$scope.loading = true;
			Studio.setAlias(CredenzialiUtente.getAlias());
			Auth.requestToken(CredenzialiUtente.getUsername(), CredenzialiUtente.getPassword()).then(
				function(tokenstring) {
					Token.set(tokenstring);
					$location.path('/' + Studio.getAlias() + '/dashboard');
				}, manageError)['finally'](function() {
				$scope.loading = false;
			});
		};

		if ($scope.presetAlias !== "") {
			$scope.user.alias = $scope.presetAlias;
			Studio.setAlias($scope.user.alias);
			RiferimentiStudio.getDati().then(function(riferimentiStudio) {
                $scope.intestazionePrincipale = riferimentiStudio.intestazioneprincipale;
                $scope.intestazioneSecondaria = riferimentiStudio.intestazionesecondaria;
				RiferimentiStudio.hasLogo().then(function(logoExists) {
					if (logoExists) {
						RiferimentiStudio.getLogo().then(function(logo) {
							$scope.urlLogo = logo;
						});
					} else {
						$scope.urlLogo = "";
					}
				});
			},function(){
				$scope.presetAlias = "";
				$scope.errors = {
					alias:true
				};
			});
		}

		var emptyfield = function() {
			return ($scope.user.alias === '' || $scope.user.username === '' || $scope.user.password === '');
		};

		var reseterrors = function() {
			$scope.errors = {
				empty: false,
				denied: false,
				cookie: false,
				alias: false,
				communication: false
			};
		};

		$scope.login = function() {
			if (!$scope.loading) {
				$scope.loading = true;

				if (emptyfield()) {
					$scope.errors.empty = true;
					$scope.loading = false;
					return;
				}

				reseterrors();

				if ($scope.presetAlias === "") {
					Studio.setAlias($scope.user.alias);
				}
				Auth.requestToken($scope.user.username, $scope.user.password).then(
					function(tokenstring) {
						Token.set(tokenstring);

						CredenzialiUtente.setUsername($scope.user.username);
						CredenzialiUtente.setPassword($scope.user.password);
						CredenzialiUtente.setAlias(Studio.getAlias());
						CredenzialiUtente.setRicordaPassword($scope.rememberLogin);

						$location.path('/' + $scope.user.alias + '/dashboard');
					}, manageError
				)['finally'](function() {
					$scope.loading = false;
				});
			}
		};

		$scope.openModalAppSecurity = function() {

			var modalInstance = $modal.open({
				animation: true,
				templateUrl: 'modules/login/view/modalAppSecurity.tpl.html',
				controller: 'ModalAppSecurityController',
				size: "lg"
			});

		};

		reseterrors();

	};

	return [
		"$scope",
		"Auth",
		"Studio",
		"Token",
		"$location",
		"$stateParams",
		"RiferimentiStudio",
		"CredenzialiUtente",
		"$modal",
		"LocalStorage",
		Controller
	];
});

